<template>
  <header class="header">
    <div class="container width-a">
      <div class="oner"><img src="../assets/oner.png" alt="学校介绍" @click="introduction"></div>
      <div class="right">
        <ul class="menus">
          <template v-for="(item, index) in menus">
            <li :class="menuIndex == index ? 'm-sed' : ''" v-bind:key="index" @click="menuTap(index)">{{item.name}}</li>
          </template>
        </ul>
        <!-- 教师 和 学生 用户 -->
        <template v-if="userInfo.roleId != null">
          <el-dropdown class="noti-container" trigger="click" @command="handleCommandB">
            <div class="noti-info">
              <img class="noti-img" src="@/assets/baner.png" alt="">
              <span class="noti-number">{{alarmNotice + alarmMsg}}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="0">
                公告消息 <span class="noti-number-b">{{alarmNotice}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command="1">
                私信消息 <span class="noti-number-b">{{alarmMsg}}</span>
              </el-dropdown-item>
              <el-dropdown-item :command="2">发送消息</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown style="min-width: 84px;cursor: pointer;" trigger="click" @command="handleCommand">
            <div class="frc">
              <img v-if="userInfo.avatar != null && userInfo.avatar != ''" style="width: 30px;height: 30px;border-radius: 15px;" :src="userInfo.avatar | fileFilter">
              <img v-if="userInfo.avatar == null || userInfo.avatar == ''" style=" width: 30px;height: 30px;border-radius: 15px;" :src="img">
              <p class="name" style="margin: 0px 6px;user-select: none;color:#f7f8fa;">{{userInfo.nickName}}</p>
              <i class="el-icon-caret-bottom" style="color:#f7f8fa"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="2">个人信息</el-dropdown-item>
              <el-dropdown-item :command="3">我的收藏</el-dropdown-item>
              <el-dropdown-item :command="4">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <!-- 默认登录 -->
        <div v-else class="login" @click="showLoginTap">
          <img class="avator" src="@/assets/avator01.png" alt="">
          <span>登录</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Auth from "@/utils/Auth"; // 验权
import CommonFilters from "@/mixins/CommonFilters";
import WebSocketUtil from "@/utils/WebSocketUtil";
export default {
  name: "MHeader",
  mixins: [CommonFilters],
  components: {},
  data () {
    return {
      menuIndex: 0,
      img: require("@/assets/avator02.png")
    };
  },
  computed: {
    menus () {
      return this.$store.state.user.menus;
    },
    userInfo () {
      return this.$store.state.user.userInfo;
    },
    alarmMsg () {
      return this.$store.state.app.alarmMsg;
    },
    alarmNotice () {
      return this.$store.state.app.alarmNotice;
    }
  },
  methods: {
    menuTap (index) {
      this.menuIndex = index;
      this.$router.push({
        path: this.menus[index].path
      });
    },
    toPath () {
      this.$router.push({
        path: "/Index"
      });
    },
    showLoginTap () {
      this.$store.commit("setShowLogin", true);
    },
    introduction () {
      this.$router.push({
        path: '/introduction'
      })
    },
    handleCommand (command) {
      let that = this;
      if (command === 4) { // 退出
        that.$router.push({
          path: "/Index"
        });
        that.HttpConnection.post("logout").then(function (res) {
          WebSocketUtil.closeWebSocket(true);
          Auth.removeToken();
          localStorage.clear();
          location.reload();
        });
      } else if (command === 2) { // 个人信息
        that.$emit("showPersonInfo", true);
      } else if (command === 3) { // 我的收藏
        that.$router.push({
          path: "/MyCollection"
        });
      }
    },
    handleCommandB (command) {
      if (command === 0) { // 公告消息
        this.$router.push({
          path: "/MessageCenter",
          query: {
            msgType: 0,
            navIndex: 0
          }
        });
      } else if (command === 1) { // 私信消息
        this.$router.push({
          path: "/MessageCenter",
          query: {
            msgType: 1,
            navIndex: 3,
          }
        });
        this.$store.commit("setAlarmMsg", 0);
      } else if (command === 2) {
        this.$router.push({
          path: "/MessageCenter",
          query: {
            msgType: 1,
            navIndex: 5
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  width: 100vw;
  height: 76px;
  background-color: rgb(44, 89, 156);
  box-shadow: 0px 8px 16px 0px rgba(44, 89, 156, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;
}

.container {
  height: 76px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.menus {
  display: flex;
  flex-direction: row;

  li {
    margin: 0px 28px 0px 0px;
    cursor: pointer;
    user-select: none;
    font-size: 16px;
    color: #c9c9c9;
  }

  li:hover {
    color: #fff;
  }

  .m-sed {
    color: #fff;
  }
}

.login {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  .avator {
    width: 30px;
    height: 30px;
    margin-right: 8px;
  }

  span {
    color: #c9c9c9;
  }
}

.oner {
  cursor: pointer;
}

.mtitle {
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
}

.noti-container {
  margin: 0px 20px 0px 10px;
}

.noti-info {
  position: relative;
  cursor: pointer;

  .noti-img {
    width: 20px;
    height: 20px;
  }

  .noti-number {
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: 10px;
    position: absolute;
    top: -14px;
    right: -14px;
    background-color: #e32727;
    color: #ffffff;
    font-size: 16px;
  }
}

.name {
  max-width: 65px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.noti-number-b {
  color: #e32727;
}
</style>